import { tss } from 'tss-react';
import { Theme } from '@mui/material/styles';

export const useStyles = tss
  .withParams<{ theme: Theme }>()
  .create(({ theme }) => ({
    ellipsis: {
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
    },
    selectedFilter: {
      height: '44px',
      cursor: 'pointer',
      border: `2px solid ${theme.palette.primary.light}`,
      borderRadius: '4px',
      padding: '10px',
      '& .MuiTypography-root': {
        color: 'black',
      },
      [theme.breakpoints.down('lg')]: {
        padding: '8px',
      },
    },
    filter: {
      cursor: 'pointer',
      border: `1px solid ${theme.palette.grey['300']}`,
      borderRadius: '4px',
      padding: '10px',
      '& .MuiTypography-root': {
        color: theme.palette.grey['500'],
      },
      [theme.breakpoints.down('lg')]: {
        padding: '8px',
      },
    },
  }));
